module.exports = __webpack_public_path__ + "img/2.246dc6a0.jpg";